import { Formik, Form } from "formik";
import * as Yup from "yup";
import MainLayout from "../../layout";
import FormTextField from "../../components/form/text";
import { FormTextAreaField } from "../../components/form/text-area";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { url } from "../../config";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import { useEffect, useState } from "react";
import ResetPasswordModal from "../../components/modal/reset-password-modal";
import backArrow from "../../assets/icons/back-arrow.svg";
import { FormDocumentField } from "../../components/form/document-upload";
import { FormDropDown } from "../../components/form/dropdown";
import Editor from "../../components/editor";
import { FormImageField } from "../../components/form/image";
import FormSlugTextField from "../../components/form/slug-input";
import { FormDateTimeField } from "../../components/form/date";
import { FormOnChangeTextField } from "../../components/form/onchange-text-field";
import { formatToDateTimeLocal } from "../../utils/text-format";

const EditNewsletter = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [openResetPassowrd, setOpenResetPassowrd] = useState(false);
  const [faqs, setFaqs] = useState([]);
  const [contentData, setContentData] = useState([]);
  const [slugStatus, setSlugStatus] = useState("");

  const checkSlugApi = async (value, form) => {
    try {
      const res = await axios.post(`${url}/slug/newsletter-slug-check`, {
        slug: value,
      });

      if (res?.data?.data?.available) {
        setSlugStatus("available");

        form.setFieldValue("slugStatus", "available");
        form.setFieldError("slug", "");

        // revalidate
        form.validateField("slug");
      } else {
        setSlugStatus("exists");

        form.setFieldValue("slugStatus", "exists");
        form.setFieldError("slug", "Slug already exists");
        form.setFieldTouched("slug", true, false);

        // revalidate
        form.validateField("slug");
      }
    } catch (err) {
      console.log("Slug API error:", err);
      setSlugStatus("");
      form.setFieldValue("slugStatus", "");
    }
  };

  const initialValues = {
    id: params?.id,
    title: data?.title ?? "",
    description: data?.description ?? "",
    meta_title: data?.meta_title ?? "",
    meta_description: data?.meta_description ?? "",
    listing_page_image: data?.listing_page_image ?? "",
    listing_page_image_alt_text: data?.listing_page_image_alt_text ?? "",
    newsletter_details_image: data?.newsletter_details_image ?? "",
    newsletter_details_image_alt_text:
      data?.newsletter_details_image_alt_text ?? "",
    author: data?.author ?? "",
    author_profile: data?.author_profile ?? "",
    author_profile_alt: data?.author_profile_alt ?? "",
    author_about: data?.author_about ?? "",
    author_social_media_link: data?.author_social_media_link ?? "",
    author_social_media_link_icon: data?.author_social_media_link_icon ?? "",
    status: data?.status ?? "draft",
    content_section: [],
    slug: data?.slug ?? "",
    property_cards_tagging: [],
    edition: data?.edition ?? "",
    date_of_published: formatToDateTimeLocal(data?.date_of_published) ?? null,
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Required"),
    description: Yup.string().required("Required"),

    listing_page_image_alt_text: Yup.string().test(
      "alt-text-required",
      "Alt text is required when an image is provided",
      function (value) {
        const { listing_page_image } = this.parent;

        if (listing_page_image && listing_page_image.length > 0) {
          return !!value;
        }

        return true;
      },
    ),

    newsletter_details_image_alt_text: Yup.string().test(
      "alt-text-required",
      "Alt text is required when an image is provided",
      function (value) {
        const { newsletter_details_image } = this.parent;

        if (newsletter_details_image && newsletter_details_image.length > 0) {
          return !!value;
        }

        return true;
      },
    ),

    author_profile_alt: Yup.string().test(
      "alt-text-required",
      "Alt text is required when an image is provided",
      function (value) {
        const { author_profile } = this.parent;

        if (author_profile && author_profile.length > 0) {
          return !!value;
        }

        return true;
      },
    ),

    slug: Yup.string().test("slug-check", "Slug already exists", function () {
      return this.parent.slugStatus !== "exists";
    }),
  });

  const handleSubmit = (values) => {
    const payload = {
      where: {
        id: values.id,
      },
      values: {
        ...values,
      },
    };

    delete payload.values.id;

    payload.values.faq = faqs;
    payload.values.content_section = contentData;

    axios
      .post(`${url}/model/newsletter_display/edit`, payload)
      .then((response) => {
        successToast(response.data.message);
        navigate(`/newsletter_display/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const fetchData = () => {
    setLoading(true);
    axios
      .post(`${url}/model/newsletter_display/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setFaqs(res.data.data.faq);
        setContentData(res.data.data.content_section);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return <p>loading</p>;
  }

  const statusList = [
    { label: "Draft", value: "draft" },
    { label: "Scheduled", value: "scheduled" },
    { label: "Published", value: "published" },
  ];

  return (
    <MainLayout>
      <ResetPasswordModal
        id={params?.id}
        isOpen={openResetPassowrd}
        onClose={() => setOpenResetPassowrd(false)}
      />

      <section className="h-full overflow-auto px-3">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ values, setFieldValue, handleChange }) => (
            <Form>
              <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
                <div className="flex items-center gap-2">
                  <button onClick={() => navigate(-1)} type="button">
                    <img src={backArrow} alt="<" width={10} height={10} />
                  </button>
                  <h2 className="text-xl font-semibold capitalize">
                    newsletter - Edit
                  </h2>
                </div>

                <div className="flex gap-3 items-center">
                  <button
                    onClick={() => navigate(-1)}
                    type="button"
                    className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                  >
                    Save
                  </button>
                </div>
              </div>
              <section className="w-full max-w-[40rem]">
                <div className="my-4">
                  <FormOnChangeTextField
                    name={"title"}
                    label={"title"}
                    placeholder={`Enter your title`}
                    maxLength={70}
                    onChange={(e) => {
                      handleChange(e);
                      setFieldValue("meta_title", e.target.value);
                    }}
                  />
                </div>
                <div className="my-4">
                  <FormTextAreaField
                    name={"description"}
                    label={"Description"}
                    placeholder={`Enter description`}
                    maxLength={160}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"meta_title"}
                    label={"meta title"}
                    placeholder={`Enter your title`}
                    maxLength={70}
                  />
                </div>
                <div className="my-4">
                  <FormTextAreaField
                    name={"meta_description"}
                    label={"meta Description"}
                    placeholder={`Enter meta description`}
                    maxLength={260}
                  />
                </div>
                <div className="my-5">
                  <FormDocumentField
                    name={"listing_page_image"}
                    label={"Listing_page_image"}
                    maxSize={2}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"listing_page_image_alt_text"}
                    label={"listing_page_image_alt_text"}
                    placeholder={`Enter listing_page_image_alt_text`}
                  />
                </div>
                <div className="my-5">
                  <FormDocumentField
                    name={"newsletter_details_image"}
                    label={"newsletter_details_image"}
                    maxSize={2}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"newsletter_details_image_alt_text"}
                    label={"newsletter_details_image_alt_text"}
                    placeholder={`Enter newsletter_details_image_alt_text`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"edition"}
                    label={"edition"}
                    placeholder={`Enter your edition`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"author"}
                    label={"author"}
                    placeholder={`Enter your author`}
                  />
                </div>
                <div className="my-4">
                  <FormImageField
                    name={"author_profile"}
                    label={"author profile picture"}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"author_profile_alt"}
                    label={"author profile alt"}
                    placeholder={`Enter author profile alt`}
                  />
                </div>
                <div className="my-4">
                  <FormTextAreaField
                    name={"author_about"}
                    label={"author about"}
                    placeholder={`Enter about`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"author_social_media_link"}
                    label={"author social media link"}
                    placeholder={`Enter social media link`}
                  />
                </div>
                <div className="my-4">
                  <FormImageField
                    name={"author_social_media_link_icon"}
                    label={"author social media link icon"}
                    maxSize={2}
                  />
                </div>
                <div className="my-4">
                  <FormSlugTextField
                    name={"slug"}
                    label={"slug"}
                    placeholder={`Enter your slug`}
                    slugValue={data?.slug}
                    checkSlugApi={checkSlugApi}
                    slugStatus={slugStatus}
                    setSlugStatus={setSlugStatus}
                  />
                </div>
                <div className="my-4">
                  <FormDateTimeField
                    name={"date_of_published"}
                    label={"date_of_published"}
                    value={values?.date_of_published}
                  />
                </div>
                <div className="my-5">
                  <FormDropDown
                    name={"status"}
                    label={"status"}
                    options={statusList}
                    value={statusList?.find(
                      (item) => item?.value === values?.status,
                    )}
                  />
                </div>
              </section>
              <div className="w-full overflow-y-auto">
                <Editor
                  contentData={contentData}
                  setContentData={setContentData}
                />
              </div>
            </Form>
          )}
        </Formik>
      </section>
    </MainLayout>
  );
};

export default EditNewsletter;
